import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3B2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;